import axios from "axios";
import { API_BASE_URL } from "../../config";

const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

/** Fetch the current P&L summary to preview before transfer */
export const getPnLSummary = async (filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters).filter(([, v]) => v !== "" && v !== null && v !== undefined)
  );
  const res = await axios.get(`${BASE}/reports/pnl`, { params });
  return res.data;
};

/** Fetch all Chart-of-Accounts entries (for the account selector) */
export const getAccounts = async () => {
  const res = await axios.get(`${BASE}/coa/`);
  return res.data;
};

/** Execute the P&L closing/transfer journal entry */
export const postPnLTransfer = async (payload) => {
  // payload: { start_date, end_date, retained_earnings_account, pnl_account, description }
  const res = await axios.post(`${BASE}/journal/pnl-transfer`, payload);
  return res.data;
};

/** Fetch history of past P&L transfers */
export const getPnLTransferHistory = async () => {
  const res = await axios.get(`${BASE}/journal/pnl-transfer-history`);
  return res.data;
};
